const Menu = [
	{
		id: 1,
		image: "../images/Oats.jpg",
		name: "Oats",
		category: "breakfast",
		price: "40₹",
		description:
			"Oats are among the healthiest grains on earth. They're a gluten-free whole grain and a great source of important vitamins, minerals, fiber, and antioxidants. Studies show that oats and oatmeal have many health benefits. These include weight loss, lower blood sugar levels, and a reduced risk of heart disease. ",
	},

	{
		id: 2,
		image: "../images/cutlet.jpg",
		name: "Veg Cutlet",
		category: "snacks",
		price: "20₹",
		description:
			"Vegetable Cutlet also called as veg cutlet are crisp, savory, tender patties made with a mix of hearty veggies, savory spices, fresh herbs and crispy breadcrumbs. Cutlet recipe is a popular snack in Indian cuisine and there are so many ways to make them. These vegan vegetable cutlet are pan fried to keep them healthy, but as you prefer you can deep fry or shallow fry.",
	},
	{
		id: 3,
		image: "../images/Idli.jpg",
		name: "Idli",
		category: "breakfast",
		price: "30₹",
		description:
			"Idlis are considered one of the healthiest Indian breakfast dishes out there. The round fluffy idlis are prepared from a rice batter that also contains ground urad dal. The batter is put in molds and steamed until it rises. It is served hot with freshly prepared sambhar curry, and chilled coconut and garlic chutneys. ",
	},
	{
		id: 4,
		image: "../images/Rice&Dal.jpg",
		name: "Rice & dal",
		category: "lunch",
		price: "50₹",
		description:
			"A combination of dal and rice have  protein synthesis, which helps build and strengthen muscles. One medium-sized katori or cup of dal-rice contains 290 kcal, 1.3 gm protein. The protein in pulses / legumes is rich in lyesin (an essential amino acid and a building block of protein). ",
	},
	{
		id: 5,
		image: "../images/Sandwich.jpg",
		name: "Cheese Sandwich",
		category: "snacks",
		price: "80₹",
		description:
			"There’s nothing more simple to make and satisfying to enjoy than a warm, crisp and gooey cheese sandwich. Here I share two ways with step-by-step photos for how to prepare an easy grilled cheese sandwich recipe in less than 20 minutes. Try your preferred recipe for a quick and yummy breakfast, lunch, or even dinner. ",
	},
	{
		id: 6,
		image: "../images/Fish Biryani.jpg",
		name: "Malabar Fish Biryani",
		category: "dinner",
		price: "180₹",
		description:
			"This classic Malabar Fish Biryani can be devoured at all times. Enjoy the delicious taste of this ever-charming dish. ",
	},
	{
		id: 7,
		image: "../images/makhani.jpg",
		name: "Veg Makhani",
		category: "dinner",
		price: "60₹",
		description:
			"A creamy, rich and delicious tomato based curry that is loaded with the goodness of butter and cashews. It tastes best with Indian breads like naan, parantha or tandoori roti. ",
	},
	{
		id: 8,
		image: "../images/Non-veg.jpg",
		name: "Non-veg",
		category: "lunch",
		price: "60₹",
		description:
			"A non-vegetarian diet includes chicken, meat, eggs and fish. A non-vegetarian diet also has several health benefits because this type of food is rich in protein and vitamin B. Non-vegetarian food strengthens our muscles and helps them grow faster. It also helps to maintain body stamina and hemoglobin. ",
	},
	{
		id: 9,
		image: "../images/samosa.jpg",
		name: "samaso",
		category: "snacks",
		price: "10₹",
		description:
			"Flaky and crunchy fried samosa are one of the most popular street food snack in North Indian cuisine. They feature a pastry-like crust but are filled with savory potatoes and peas for a hearty, delicious snack. This step-by-step recipe guide will help you to make the flakiest, tastiest, absolutely best Punjabi Samosa or Aloo Samosa from scratch!. ",
	},
];

export default Menu;
